module.exports = __webpack_public_path__ + "static/media/ic_screeshare_zoom.ee3e5125.svg";